import { useLanguage } from "locales"

import styles from "./YesNoToggle.module.scss"

interface YesNoToggleProps {
  // undefined: nothing selected (state not loaded yet, or setting unavailable)
  value?: boolean
  disabled?: boolean
  onYes: () => void
  onNo: () => void
}

const YesNoToggle = ({ value, disabled, onYes, onNo }: YesNoToggleProps) => {
  const { languages } = useLanguage()

  return (
    <div className={disabled ? `${styles.Toggle} ${styles.Disabled}` : styles.Toggle}>
      <button
        type="button"
        className={value === false ? `${styles.Option} ${styles.No}` : styles.Option}
        disabled={disabled}
        onClick={() => value !== false && onNo()}
      >
        {languages.no}
      </button>
      <button
        type="button"
        className={value === true ? `${styles.Option} ${styles.Yes}` : styles.Option}
        disabled={disabled}
        onClick={() => value !== true && onYes()}
      >
        {languages.yes}
      </button>
    </div>
  )
}

export default YesNoToggle
